import React from 'react';
import { ContentWrapper } from '../../../styles/shared';
import { ProductSeoTag } from '../../../models/domain/interfaces';

const ProductSeoTags: React.FC<any> = ({
  data: { seoTags },
}: {
  data: {
    seoTags?: ProductSeoTag;
  };
}) => {
  if (!seoTags) return <></>;

  return (
    <ContentWrapper>
      {seoTags?.seoText && (
        <div dangerouslySetInnerHTML={{ __html: seoTags.seoText }}></div>
      )}
    </ContentWrapper>
  );
};

export default ProductSeoTags;
